module.exports = __webpack_public_path__ + "static/city-network-686e751307789f6475a1d01d77584116.jpg";